export const GET_INDICATORS = 'GET_INDICATORS';
export const GET_INDICATORS_SUCCESS = 'GET_INDICATORS_SUCCESS';
export const GET_INDICATORS_FAIL = 'GET_INDICATORS_FAIL';

export const ADD_INDICATOR = 'ADD_INDICATOR';
export const ADD_INDICATOR_SUCCESS = 'ADD_INDICATOR_SUCCESS';
export const ADD_INDICATOR_FAIL = 'ADD_INDICATOR_FAIL';

export const UPDATE_INDICATOR = 'UPDATE_INDICATOR';
export const UPDATE_INDICATOR_SUCCESS = 'UPDATE_INDICATOR_SUCCESS';
export const UPDATE_INDICATOR_FAIL = 'UPDATE_INDICATOR_FAIL';

export const DELETE_INDICATOR = 'DELETE_INDICATOR';
export const DELETE_INDICATOR_SUCCESS = 'DELETE_INDICATOR_SUCCESS';
export const DELETE_INDICATOR_FAIL = 'DELETE_INDICATOR_FAIL';

export const SET_INDICATOR_FIELD_ERRORS = 'SET_INDICATOR_FIELD_ERRORS';
